import clamp from 'clamp-js';
import debounce from 'lodash/debounce';
import { getBreakpoint } from '../../../../design3/asset-build/js/custom/_utils';

const baseClass = 'HoverCardGrid';
const cardClass = `${baseClass}-GenericCard`;
const showDescription = `${cardClass}-description--show`;

const selectors = {
	container: `.${baseClass}--js`,
	card: `.${baseClass}-GenericCard`,
	cardDescription: `.${baseClass}-GenericCard-description`,
};

export default function initHoverCardGrid() {
	$(selectors.container)
		.find(selectors.card)
		.each(function () {
			const $card = $(this);
			if (!$card.hasClass('card-listeners-setup')) {
				$card.addClass('card-listeners-setup');
				const $cardDescripton = $(this).find(selectors.cardDescription);

				// eslint-disable-next-line no-inner-declarations
				function clampText() {
					$cardDescripton.html(originalHtml);
					$cardDescripton.css('height', 'auto');
					$cardDescripton.addClass(showDescription);
					clamp($cardDescripton[0], { clamp: 5, useNativeClamp: false });
					cardHeight = $cardDescripton.height();
					$cardDescripton.css('height', 0);
					$cardDescripton.removeClass(showDescription);
				}

				const originalHtml = $cardDescripton.html();
				let cardHeight = 0;

				clampText();

				$card.on('mouseenter focusin', function () {
					if (getBreakpoint() === 'large' || getBreakpoint() === 'xlarge') {
						$cardDescripton.css('height', cardHeight);
						$cardDescripton.addClass(showDescription);
					}
				});
				$card.on('mouseleave focusout', function () {
					$cardDescripton.css('height', 0);
					$cardDescripton.removeClass(showDescription);
				});

				$(window).on('resize', debounce(clampText, 150));
			}
		});
}
window.FS = window.FS || {};
window.FS.initHoverCardGrid = initHoverCardGrid;
